
// 批复状态
export const approvedStateList = [
  {name: '处理中', value: 1},
  {name: '失败', value: 0},
  {name: '成功', value: 2}
]

export const getApprovedStateName = (state) => {
  if (typeof state !== 'number') {
    state = Number(state)
  }
  const result = approvedStateList.find(item => item.value === state)
  return typeof result === 'undefined' ? '-' : result.name
}


// WEBPACK FOOTER //
// ./src/config/approvedState.js